import * as React from "react";
const SvgFiRrMessagesQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-messages-question_svg__a)">
      <path
        fill="#062147"
        d="M19 4h-1.101A5.01 5.01 0 0 0 13 0H5C2.243 0 0 2.243 0 5v12.854a2.145 2.145 0 0 0 2.149 2.149c.416 0 .831-.121 1.19-.36l2.95-1.967A5.01 5.01 0 0 0 11 21h5.697l3.964 2.644a2.15 2.15 0 0 0 2.205.104A2.15 2.15 0 0 0 24 21.854V9c0-2.757-2.243-5-5-5M2.23 17.979c-.019.012-.074.048-.152.007-.079-.042-.079-.109-.079-.131V5c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3v7c0 1.654-1.346 3-3 3h-6c-.306 0-.541.159-.565.175zM22 21.855c0 .021 0 .089-.078.131-.08.043-.134.006-.152-.007l-4.215-2.811A1 1 0 0 0 17 19h-6a3 3 0 0 1-2.828-2H13c2.757 0 5-2.243 5-5V6h1c1.654 0 3 1.346 3 3zM6 7a2.996 2.996 0 0 1 3.535-2.952 3.02 3.02 0 0 1 2.417 2.417 3.02 3.02 0 0 1-1.506 3.164c-.447.246-.447.318-.447.371a1 1 0 1 1-2 0c0-1.308 1.038-1.879 1.481-2.123.29-.159.595-.535.502-1.066a1 1 0 0 0-.793-.793 1 1 0 0 0-.832.216 1 1 0 0 0-.358.767 1 1 0 1 1-2 0zm4 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-messages-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMessagesQuestion;
